import { Switchboard } from "../../../events";
import { ToolbarButton } from "./ToolbarButton";
export class ContextButton extends ToolbarButton {
    constructor(icon, description, id) {
        super(icon, description, id);
        this.ctx = '';
        this.emitter = Switchboard.get_emitter("CONTEXT");
    }
    set_context(ctx) {
        this.ctx = ctx;
        return this;
    }
    _action() {
        this.emitter.emit('req_or_revert', this.ctx);
    }
}
